import PropTypes from 'prop-types';
import { useContext, useMemo } from 'react';
// material
import { CssBaseline } from '@mui/material';
import {
  createTheme,
  StyledEngineProvider,
  ThemeProvider as MUIThemeProvider,
} from '@mui/material/styles';
//
import React from 'react';
import { SwitchThemeContext } from '../contexts/theme/SwitchTheme';
import componentsOverride from './overrides';
import palette from './Palette';
import shadows, { customShadows } from './shadows';
import typography from './typography';
// ----------------------------------------------------------------------

ThemeProvider.propTypes = {
  children: PropTypes.node,
};

export default function ThemeProvider({ children }) {
  const [switchTheme] = useContext(SwitchThemeContext);
  const { mode } = switchTheme;
  const themeOptions = useMemo(
    () => ({
      palette: palette(mode),
      shape: { borderRadius: 8 },
      typography,
      shadows: shadows(mode),
      customShadows: customShadows(mode),
    }),
    [mode],
  );

  const theme = createTheme(themeOptions);
  theme.components = componentsOverride(theme);

  return (
    <StyledEngineProvider injectFirst>
      <MUIThemeProvider theme={theme}>
        <CssBaseline />
        {children}
      </MUIThemeProvider>
    </StyledEngineProvider>
  );
}
